@import '../../sass/components/badges';

:host(*) {
  line-height: 1.25rem;
}

:host(.badge-dismissed) {
  display: none!important;
  visibility: hidden!important;
}
